import { call, put, takeLatest } from "@redux-saga/core/effects";
import {
  PROFILE_ACTION,
  responseProfileAction,
  errorProfileAction,
  responseUpdateProfileForUser,
  errorUpdateProfileForUser,
  responseUploadProfilePicture,
  errorUploadProfilePicture,
  responseGetProfilePicture,
  errorGetProfilePicture,
  errorUploadCoverImage,
  responseUploadCoverImage,
  responseGetCoverImage,
  errorGetCoverImage,
} from "./ProfileActionCreator";
import UserService from "../../Services/RestApiManager/UserManager/UserService";
import ProfileService from "../../Services/RestApiManager/ProfileManager/ProfileService";

export function* profileRequest(action) {
  try {
    const response = yield call(
      UserService.shared.userByIdRequest,
      action.data
    ); 
    yield put(responseProfileAction(response));
  } catch (error) {
    yield put(errorProfileAction(error));
  }
}
export function* updateProfileUserRequest(action) {
  try {
    const response = yield call(
      ProfileService.shared.updateprofileUserRequest,
      action.data
    );
    if (response) {
      localStorage.setItem("userDetails", JSON.stringify(response));
      yield put(responseUpdateProfileForUser(response));
    }
  } catch (error) {
    yield put(errorUpdateProfileForUser(error));
  }
}

export function* uploadProfilePictureRequest(action) {
  try {
    const response = yield call(
      ProfileService.shared.uploadProfilePictureRequest,
      action.data
    );
    if (response) {
      yield put(responseUploadProfilePicture(response));
    }
  } catch (error) {
    yield put(errorUploadProfilePicture(error));
  }
}

export function* getProfilePictureRequest(payload) {
  try {
    const response = yield call(
      ProfileService.shared.getProfilePictureRequest,
      payload.data
    );
    if (response) {
      yield put(responseGetProfilePicture(response));
    }
  } catch (error) {
    yield put(errorGetProfilePicture(error));
  }
}
export function* uploadCoverImageRequest(action) {
  try {
    const response = yield call(
      ProfileService.shared.uploadCoverImageRequest,
      action.data
    );
    if (response) {
      yield put(responseUploadCoverImage(response));
    }
  } catch (error) {
    yield put(errorUploadCoverImage(error));
  }
}

export function* getCoverImageRequest(payload) {
  try {
    const response = yield call(
      ProfileService.shared.getCoverImageRequest,
      payload.data
    );
    if (response) {
      yield put(responseGetCoverImage(response));
    }
  } catch (error) {
    yield put(errorGetCoverImage(error));
  }
}

export function* profileWatcherSaga() {
  yield takeLatest(PROFILE_ACTION.REQUEST_PROFILE, profileRequest);
  yield takeLatest(
    PROFILE_ACTION.REQUEST_UPDATE_PROFILE_FOR_USER,
    updateProfileUserRequest
  );
  yield takeLatest(
    PROFILE_ACTION.REQUEST_UPLOAD_PROFILE_PICTURE,
    uploadProfilePictureRequest
  );
  yield takeLatest(
    PROFILE_ACTION.REQUEST_GET_PROFILE_PICTURE,
    getProfilePictureRequest
  );
  yield takeLatest(
    PROFILE_ACTION.REQUEST_UPLOAD_COVER_IMAGE,
    uploadCoverImageRequest
  );
  yield takeLatest(
    PROFILE_ACTION.REQUEST_GET_COVER_IMAGE,
    getCoverImageRequest
  );
}
